import * as types from './types';

export const getDishOptions = payload => ({
  type: types.DISH_OPTIONS_CATEGORY_GET_REQUEST,
  payload,
});

export const changeFormStep = payload => ({
  type: types.CHANGE_DISH_OPTIONS_FORM_STEP,
  payload,
});

export const updateOrCreate = payload => ({
  type: types.DISH_OPTIONS_CATEGORY_CREATE_OR_UPDATE_REQUEST,
  payload,
});

export const resetListData = () => ({
  type: types.RESET_DISH_OPTIONS_LIST_DATA,
});

export const resetErrors = () => ({
  type: types.DISH_OPTIONS_CATEGORY_CREATE_OR_UPDATE_FAILURE,
  payload: null,
});

export const deleteOptions = payload => ({
  type: types.DISH_OPTIONS_CATEGORY_DELETE_REQUEST,
  payload,
});
